import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { Tab } from '@/components/ui/tab';

export function Tabs() {
  const intl = useIntl();
  const location = useLocation();

  const pathParts = location.pathname.split('/');
  const activeTab = pathParts[pathParts.length - 1];

  return (
    <div className="flex items-center gap-2">
      <Tab
        title={intl.formatMessage({
          defaultMessage: 'Automation',
          description:
            'Settings tab: rules that pause or resume sourcing spend',
        })}
        to="automation"
        isActive={activeTab === 'automation'}
      />
      <Tab
        title={intl.formatMessage({
          defaultMessage: 'Channel Enablement',
          description:
            'Settings tab: turn integrations on/off and map UTM traffic',
        })}
        to="channels"
        isActive={activeTab === 'channels'}
      />
      <Tab
        title={intl.formatMessage({
          defaultMessage: 'Dashboard',
          description: 'Settings tab: dashboard',
        })}
        to="dashboard"
        isActive={activeTab === 'dashboard'}
      />
    </div>
  );
}
